import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-three-sixty-viewer-controls',
  templateUrl: './three-sixty-viewer-controls.component.html',
  styleUrls: ['./three-sixty-viewer-controls.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ThreeSixtyViewerControlsComponent {
  @Input() isAutoplaying = false;
  @Input() progressOffset = 0;
  @Input() circumference = 1;

  @Output() prevFrameHold = new EventEmitter<void>();
  @Output() nextFrameHold = new EventEmitter<void>();
  @Output() stopHold = new EventEmitter<void>();
  @Output() toggleAutoplay = new EventEmitter<void>();
}
